import { Message } from "../../streaming/streaming-message-types";
import { stripHiddenContext } from "../../utils/messageUtils";
import { PlainTextContent } from "../content/PlainTextContent";
import { MessageBubble } from "../primitives/MessageBubble";
import { MessageShell } from "../primitives/MessageShell";

export interface UserMessageProps {
  message: Message;
  disableAnimations?: boolean;
}

/**
 * UserMessage component for rendering user messages.
 * Simple, focused component that handles only user message display.
 */
export const UserMessage = ({
  message,
  disableAnimations = false,
}: UserMessageProps) => {
  /**
   * User messages could contain tool call respones.
   * Normally these responses are just a bunch of tool calls.
   * We check if that is the case. If not, there should be only
   * one type:text item in the user message.
   * We don't render the messages that are tool respones.
   */

  let content = "";
  if (Array.isArray(message.content)) {
    content = message.content
      .filter((contentEntry) => {
        return contentEntry.type === "text";
      })
      .map((contentWithText) => {
        return contentWithText.text;
      })
      .reduce((acc, val) => {
        return acc + val;
      }, "");
  } else {
    content = message.content;
  }

  if (!content) {
    return null;
  }

  // Strip hidden context markers before displaying to user
  const displayContent = stripHiddenContext(content);

  if (!displayContent) {
    return null;
  }

  return (
    <MessageShell alignment="right" disableAnimations={disableAnimations}>
      <MessageBubble variant="user">
        <PlainTextContent content={displayContent} />
      </MessageBubble>
    </MessageShell>
  );
};
